import type { Action } from 'history';
import { useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router';

type ScrollToTopProps = {
  disableScrollOnQueryUpdate?: boolean;
};

const isScrollToTopAction = (action: Action) =>
  !['POP', 'REPLACE'].includes(action);

export const ScrollToTop = ({
  disableScrollOnQueryUpdate,
}: ScrollToTopProps) => {
  const { pathname, search } = useLocation();
  const { action } = useHistory();
  const path = useMemo(
    () => pathname + (disableScrollOnQueryUpdate ? '' : search),
    [pathname, search, disableScrollOnQueryUpdate]
  );
  useEffect(() => {
    if (isScrollToTopAction(action)) {
      window.scroll(0, 0);
    }
  }, [action, path]);
  return null;
};
